// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__27WDk","title":"InfoRow_title__I4aYT"};